module.exports = __webpack_public_path__ + "static/video_still_journey-8a94a9fcf8e332b0625b86135d098dc3.jpg";